
function SupportIcon() {
	return (
		<svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<g
				fill="#FFFFFF"
				stroke="#FFFFFF"
				strokeLinecap="square"
				strokeLinejoin="miter"
				strokeMiterlimit="10"
				strokeWidth="2"
			>
				<path d="M4,17.584V19 c0,2.209,1.791,4,4,4h4" fill="none" strokeLinecap="butt" />
				<path d="M4,8.406V8c0-3.866,3.134-7,7-7 h2c3.866,0,7,3.134,7,7v0.422" fill="none" strokeLinecap="butt" />
				<path
					d="M7,8.101 C6.677,8.035,6.343,8,6,8c-2.761,0-5,2.239-5,5s2.239,5,5,5c0.343,0,0.677-0.035,1-0.101V8.101z"
					fill="none"
					stroke="#FFFFFF"
				/>
				<path
					d="M17,17.899 C17.323,17.965,17.657,18,18,18c2.761,0,5-2.239,5-5s-2.239-5-5-5c-0.343,0-0.677,0.035-1,0.101V17.899z"
					fill="none"
					stroke="#FFFFFF"
				/>
			</g>
		</svg>
	);
}

export default SupportIcon;
